import { CHAPTERS } from "../data/content";
import { Reveal } from "./Reveal";

export const Manifesto = () => (
  <section id="manifesto" data-testid="manifesto" className="relative py-28 md:py-44">
    <div className="mx-auto max-w-[1600px] px-6 md:px-12">
      <Reveal>
        <div className="flex items-baseline gap-4 mb-16 md:mb-28">
          <span className="font-mono-bds text-xs uppercase tracking-[0.3em] text-bds-accent">
            The Manifesto
          </span>
          <span className="flex-1 h-px bg-bds-border" />
        </div>
      </Reveal>

      <div className="md:grid md:grid-cols-12">
        <div className="md:col-start-4 md:col-span-9">
          {CHAPTERS.map((c, i) => (
            <Reveal key={c.n} delay={i * 0.05}>
              <article className="grid grid-cols-1 md:grid-cols-12 gap-6 md:gap-10 py-12 md:py-16 border-b border-bds-border group">
                <div className="md:col-span-2">
                  <span className="font-mono-bds text-sm text-bds-muted group-hover:text-bds-accent transition-colors">
                    {c.n} / 04
                  </span>
                </div>
                <div className="md:col-span-10">
                  <h3 className="font-serif-display font-light text-3xl md:text-5xl lg:text-6xl tracking-tight leading-[1.02] mb-6">
                    {c.title}
                  </h3>
                  <p className="font-grotesk text-base md:text-lg text-bds-muted leading-relaxed max-w-2xl">
                    {c.body}
                  </p>
                </div>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </div>
  </section>
);
